import Iconify from 'src/components/iconify/Iconify';
import { NavItem } from 'src/features/Navbar/NavItem';
export type NavDriveActionsList = {
  icon: string;
  name: string;
  action?: string;
  divider: boolean;
};

type Props = {
  driveItem: NavDriveActionsList;
};
export const DriveNavItem = ({ driveItem }: Props) => {
  return (
    <NavItem
      depth={1}
      path={driveItem?.action || ''}
      icon={<Iconify icon={driveItem.icon} />}
      linkActiveMatchChildren
      sx={{ mb: 0.5 }}
    >
      {driveItem.name}
    </NavItem>
  );
};
